import {
  Button,
  CollectionLetterSummary,
  Div,
  H5,
  Modal,
  copyToClipboard,
} from '@vgrubs/components';
import { summaryToText } from '../hooks/useCollectionLetterSummary';
import { BulletList } from './RepaymentSuggestion.styled';

type Props = {
  /** Open while there is one; it is only passed once it has loaded. */
  summary: CollectionLetterSummary | undefined;
  onClose: () => void;
};

/**
 * The collection letter as notes for a call with the restaurant: the
 * backend's sections, in the order they come, each a list of bullets shown
 * as plain text. Copy puts the whole of it on the clipboard for the call
 * notes.
 */
export const CallSummaryModal = ({ summary, onClose }: Props) => (
  <Modal
    isOpen={!!summary}
    closeModal={onClose}
    logo={false}
    width="720px"
    textAlign="left"
    header="Call summary"
    subtitle={
      summary
        ? `${summary.locationName} · ${summary.totalFormatted}`
        : undefined
    }
    $numOfFloatingButtons={1}
    footer={
      summary && (
        <Button
          $selected
          $w="100%"
          $wSM="100%"
          onClick={() => copyToClipboard(summaryToText(summary))}
        >
          Copy
        </Button>
      )
    }
  >
    {summary && (
      <Div $flex $column $gap="24px">
        {summary.sections.map((section, index) => (
          <Div key={index}>
            <H5 $m="0 0 8px">{section.title}</H5>
            <BulletList>
              {section.bullets.map((bullet, bulletIndex) => (
                <li key={bulletIndex}>{bullet}</li>
              ))}
            </BulletList>
          </Div>
        ))}
      </Div>
    )}
  </Modal>
);
